export interface Lineup {
  id: string;
  league: string;
  match: string;
  homeTeam: string;
  awayTeam: string;
  time: string;
  homeFormation: string;
  awayFormation: string;
  homeLineup: string[];
  awayLineup: string[];
  homeSubstitutes: string[];
  awaySubstitutes: string[];
}

export const lineups: Lineup[] = [
  {
    id: "lu1",
    league: "프리미어리그",
    match: "첼시 vs 아스널",
    homeTeam: "첼시",
    awayTeam: "아스널",
    time: "14:00",
    homeFormation: "4-3-3",
    awayFormation: "4-2-3-1",
    homeLineup: ["산체스", "쿠쿠렐라", "콜윌", "디사시", "리스 제임스", "카이세도", "엔조", "페르난데스", "마두에케", "잭슨", "팔머"],
    awayLineup: ["라야", "진첸코", "살리바", "가브리엘", "화이트", "라이스", "파티", "헤베르츠", "외데고르", "사카", "제주스"],
    homeSubstitutes: ["베티넬리", "바디아실", "토드", "루이브", "카사데이", "디우", "암추아", "미아이치", "엘리엇", "엔쿤쿠", "조지우", "구스토"],
    awaySubstitutes: ["넷오", "키워르", "팀버", "포르투", "우파메카노", "마이르", "이스파", "우파메카노", "우파메카노", "키워르", "우파메카노", "우파메카노"],
  },
  {
    id: "lu2",
    league: "분데스리가",
    match: "바이에른 뮌헨 vs 도르트문트",
    homeTeam: "바이에른 뮌헨",
    awayTeam: "도르트문트",
    time: "16:30",
    homeFormation: "4-2-3-1",
    awayFormation: "4-3-3",
    homeLineup: ["노이어", "키미히", "우파메카노", "킴", "그리말도", "파빌로비치", "키미히", "무시알라", "올리세", "코만", "케인"],
    awayLineup: ["코벨", "뤼흐센", "슬로테베크", "안톤", "본", "엔메차", "사비처", "브란트", "아데예미", "지라시", "마伦"],
    homeSubstitutes: ["페레인", "스탈니히", "다이르", "레이머", "그뤼엔베르크", "팔리니아", "하그리브스", "뮐러", "사네", "뮐러", "뮐러", "뮐러"],
    awaySubstitutes: ["마이어", "라이머", "카메라", "라이머", "카메라", "라이머", "카메라", "라이머", "카메라", "라이머", "카메라", "라이머"],
  },
  {
    id: "lu3",
    league: "KBO",
    match: "삼성 vs LG",
    homeTeam: "삼성",
    awayTeam: "LG",
    time: "19:00",
    homeFormation: "-",
    awayFormation: "-",
    homeLineup: ["구자욱", "김현준", "맥키넌", "김영웅", "이재현", "김지찬", "강민호", "안주형", "이성규"],
    awayLineup: ["홍창기", "박해민", "김현수", "오스틴", "문보경", "김동혁", "박동원", "신민재", "이주형"],
    homeSubstitutes: ["김대한", "김성윤", "이학주", "이원석", "강백호", "이지영", "최하늘", "임재현", "이승현", "백승현", "이승민", "정우영"],
    awaySubstitutes: ["이성우", "최원준", "이재원", "이원재", "김범석", "정주현", "최지훈", "이주형", "김민성", "김윤식", "이정용", "김유영"],
  },
  {
    id: "lu4",
    league: "프리미어리그",
    match: "토트넘 vs 리버풀",
    homeTeam: "토트넘",
    awayTeam: "리버풀",
    time: "20:00",
    homeFormation: "4-3-3",
    awayFormation: "4-3-3",
    homeLineup: ["비카리오", "우도지", "반 더 펜", "로메로", "포로", "벤탕쿠르", "비수마", "매디슨", "존슨", "손흥민", "쿠루세브스키"],
    awayLineup: ["알리송", "로버트슨", "반 다이크", "코나테", "아놀드", "맥알리스터", "소보슬라이", "존스", "디아스", "누네스", "살라"],
    homeSubstitutes: ["오스틴", "드라구신", "스팬스", "댈윈", "그레이", "페르피슨", "비스마", "소", "존슨", "그레이", "손흥민", "쿠루세브스키"],
    awaySubstitutes: ["카이레헤", "네이러", "킨더슨", "게라트츠", "엔도", "후", "강", "엔도", "후", "강", "엔도", "후"],
  },
  {
    id: "lu5",
    league: "라리가",
    match: "레알 마드리드 vs 바르셀로나",
    homeTeam: "레알 마드리드",
    awayTeam: "바르셀로나",
    time: "22:30",
    homeFormation: "4-3-3",
    awayFormation: "4-3-3",
    homeLineup: ["쿠르투아", "멘디", "미利탕", "바예호", "바스케스", "흐비체스", "추아메니", "바르드", "비니시우스", "음바페", "로드리고"],
    awayLineup: ["테르 슈테겐", "발데", "쿠바르시", "이니고", "칸셀로", "페드리", "바이도", "데 용", "라피냐", "레반도프스키", "야말"],
    homeSubstitutes: ["루닌", "프란", "뤼드리", "아라바", "모드리치", "흐비체스", "추아메니", "바르드", "비니시우스", "음바페", "로드리고", "흐비체스"],
    awaySubstitutes: ["페냐", "마르틴", "몬주", "페드리", "바이도", "데 용", "라피냐", "레반도프스키", "야말", "페드리", "바이도", "데 용"],
  },
];